// removed by extract-text-webpack-plugin
module.exports = {"form":"form__1SNZS","phone":"phone__3Kd9y form__1SNZS","input":"input__Uyc_5","button":"button__1zR14","skip":"skip__3OnHM"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/styles/input.scss
// module id = tTv0
// module chunks = 0